import { render } from "./StartValidatorModal.vue?vue&type=template&id=05b70e24&scoped=true"
import script from "./StartValidatorModal.vue?vue&type=script&lang=js"
export * from "./StartValidatorModal.vue?vue&type=script&lang=js"

import "./StartValidatorModal.vue?vue&type=style&index=0&id=05b70e24&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05b70e24"]])

export default __exports__